/**
 * Development-only fallback user ID. Used when sessionStorage['data'] is not set
 * (i.e., the app is running outside the mobile webview context during local dev).
 * This is a non-privileged test account with no special permissions.
 */
export const DEV_FALLBACK_USER_ID = 'jWjeLoO8C3NG9fmFm1icAq1c33E2';

const getUserId = () => {
	return window.sessionStorage.getItem('data');
};

const getUserMode = () => {
	return window.sessionStorage.getItem('internal');
};

const getUserIdWithFallback = () => {
	return window.sessionStorage.getItem('data') ?? DEV_FALLBACK_USER_ID;
};

const getUserIdFromSessionOrUrl = () => {
	const sessionData = window.sessionStorage.getItem('data');
	if (sessionData) {
		return sessionData;
	}
	const urlParams = new URLSearchParams(window.location.search);
	const urlData = urlParams.get('data');
	if (urlData) {
		return urlData;
	}
	return null;
};

export async function followUser(userId) {
	const baseAxios = (await import('./baseAxios')).default;
	if (!userId) return null;

	try {
		const body = {
			selfUserId: getUserId(),
			type: 'follow',
			data: {
				followee: userId,
			},
		};

		const resp = await baseAxios({
			endPoint: 'userProfile',
			data: body,
		});

		return resp;
	} catch (err) {
		return null;
	}
}

export { getUserId, getUserIdWithFallback, getUserMode, getUserIdFromSessionOrUrl };
